module.exports = __webpack_public_path__ + "img/img_045@2x.fdbb5960.png";